/**
 * Single, consistent action button for the SuperAdmin listings.
 *
 * variant: "primary" (brand gradient) | "outline" (edit/secondary) |
 *          "danger" (delete) | "warning" (utility accent)
 *
 * Renders a plain <button> styled via .admin-btn so it stays isolated from the
 * global .button / react-bootstrap variant styles.
 */
export default function AdminButton({ variant = "primary", className = "", children, ...rest }) {
  return (
    <button type="button" className={`admin-btn admin-btn--${variant} ${className}`.trim()} {...rest}>
      {children}
    </button>
  );
}
